export default __webpack_public_path__ + "i18n/translation-sv.5bffed10.json";